import { render, staticRenderFns } from "./Categolies.vue?vue&type=template&id=ad09a4b8&scoped=true&"
import script from "./Categolies.vue?vue&type=script&lang=js&"
export * from "./Categolies.vue?vue&type=script&lang=js&"
import style0 from "./Categolies.vue?vue&type=style&index=0&id=ad09a4b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad09a4b8",
  null
  
)

export default component.exports